import React from 'react';
import NavigationComponent from '../../../commonComponents/util/NavigationComponent';
import ValidatedInput from '../../../commonComponents/util/ValidatedInput';
import CurrencyFormatInput from '../../../commonComponents/util/CurrencyFormatInput';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';
import WarningModal from '../../../commonComponents/shared/WarningModal';
import ReceivingParticipantsTable from "./ReceivingParticipantsTable";
import { formatCurrency, stripCurrencyFormat } from '../../../../lib/utils';

const initialState = {
    submitAttempted: false,
    checkAddListRule: true,
    promptReceivedPast60days: false,
    promptDuplicateApplications : false,
    error: false,
    showModals: {
        campaign60DayRuleAlertModal: false,
        duplicateApplicationsAlertModal: false
    }
};

export default class WizardStep3 extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    componentWillUnmount() {
        this.setState(initialState);
    }

    async onSubmit() {
        this.setState({ submitAttempted: true, error: false }); //submit attempted was used to show required indication when default amount was required.  did not remove this property - waiting to see if implementation will be reverted to original way.

        if (this.props.defaultAmount > this.props.maxAmount) return;

        await this.props.submit(!this.state.checkAddListRule);

        if (this.props.error) {
            if ((this.state.checkAddListRule)
                && this.props.message && (this.props.message.indexOf("60 days") >= 0 ||
                                          this.props.message.indexOf("another application") >= 0)) {
                
                const promptDuplicateApplications = this.props.message.indexOf("another application") >= 0;
                const promptReceivedPast60days = !promptDuplicateApplications || this.props.message.indexOf("|") >= 0;

                this.setState({ promptReceivedPast60days, promptDuplicateApplications },
                    this.toggleModal.bind(this, promptReceivedPast60days ? 'campaign60DayRuleAlertModal' : 'duplicateApplicationsAlertModal'));
                
            } else {
                this.setState({ error: true });
            }
        }
    }

    onPrevious() {
        this.props.clearReceivingParticipants();
        this.props.previous();
    }

    render() {
        const totalCount = this.props.receivingParticipants.data.totalCount;
        return (
            <div className="wizard-step-3">
                <div className="modal-section">
                    <div className="column-half">
                        <ValidatedInput input={<CurrencyFormatInput isIsraeli={this.props.isIsraeli} />}
                            label="Enter the default amount for this list" name="defaultAmount" value={this.props.defaultAmount}
                            onChange={(name, val) => this.props.updateDefaultAmount(val)}
                            validated={true} showValidationError={true}
                            validate={val => !val || stripCurrencyFormat(val) <= this.props.maxAmount}
                            errorMessage={`Default amount cannot exceed ${formatCurrency(this.props.maxAmount, this.props.isIsraeli)}.`} />
                    </div>
                </div>
                {totalCount > 0 && <div className="modal-section">
                    <p className="applicant-amount accent-text2">{totalCount} Application{totalCount === 1 ? '' : 's'}</p>
                    <p className="small-text">will be added to {this.props.campaignName ? `the ${this.props.campaignName}` : 'this'} Campaign</p>
                </div>}
                <div className="modal-table">
                  <ReceivingParticipantsTable
                    {...this.props.receivingParticipants}
                    rejectedParticipants={this.props.rejectedParticipants}
                    updateRejectedParticipants={(this.props.updateRejectedParticipants)}
                    newParticipants={this.props.newParticipants}
                    getReceivingParticipants={this.props.getReceivingParticipants}
                  />
                </div>
                <hr />
                
                {this.props.submitting ? <LoadingSpinner height="20" alignRight={true} /> : <div className="modal-error-container">
                    <div className="warning-modal-btns modal-btns text-right relative">
                        <button className="btn btn-primary" onClick={this.onPrevious.bind(this)}>Previous</button>
                        <button className="btn btn-accent" onClick={this.props.close}>Cancel</button>
                        <button className="btn btn-primary" onClick={this.onSubmit.bind(this)}>Submit</button>
                    </div>
                    <FadeOutErrorMessage show={this.state.error} message={this.props.message || "Something went wrong and the verification process could not be completed.  Please try again."} /></div>}

                <WarningModal
                    show={this.state.showModals.campaign60DayRuleAlertModal}
                    close={this.toggleModal.bind(this, "campaign60DayRuleAlertModal")}
                    message={(this.props.message || "").split('|')[0]}
                    continue={() => {
                        this.setState({ checkAddListRule: false }, 
                            this.state.promptDuplicateApplications ? this.toggleModal.bind(this, 'duplicateApplicationsAlertModal') : this.onSubmit);
                    }}
                    cancel={() => {
                        this.setState({ checkAddListRule: true });
                    }} />

                 <WarningModal
                    show={this.state.showModals.duplicateApplicationsAlertModal}
                    close={this.toggleModal.bind(this, "duplicateApplicationsAlertModal")}
                    message={(this.props.message || "").split('|')[(this.props.message || "").split('|').length - 1]}
                    continue={() => {
                        this.setState({ checkAddListRule: false }, this.onSubmit);
                    }}
                    cancel={() => {
                        this.setState({ checkAddListRule: true });
                    }} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/VerifyCampaignListWizard/WizardStep3.jsx